import { cleanNumber, isValidNumber } from '@gripp/shared-logic';
import { useState } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { Colors } from '../../../themes';
import { MaskedNumberInput } from '../../forms';
import { CounterExecutionComponentProps } from './counterExecutionComponent';

export const SimpleCounterExecutionComponent = (
  props: CounterExecutionComponentProps
) => {
  // Use props.value if available (from form/draft or revision), otherwise blank
  const [inputValue, setInputValue] = useState<string>(
    props.value != null && !Number.isNaN(props.value)
      ? props.value.toString()
      : ''
  );

  const change = (raw: string) => {
    if (raw === '') {
      setInputValue('');
      props.onChange(NaN as any);
      return;
    }
    const input = cleanNumber(raw, props.decimalPlaces, true);
    setInputValue(input);
    if (isValidNumber(input)) {
      const num = parseFloat(input);
      props.onChange(num);
    } else {
      props.onChange(NaN as any);
    }
  };

  return (
    <View
      style={props.containerStyle ? props.containerStyle : styles.container}
    >
      {props.instructions?.trim() !== '' && (
        <Text style={styles.sectionTitle}>{props.instructions}</Text>
      )}
      <View style={[styles.inputContainer, props?.inputContainerStyle]}>
        <MaskedNumberInput
          value={inputValue}
          decimalPlaces={props.decimalPlaces}
          autoFocus={props.autoFocus}
          onFocus={props.onFocus}
          onBlur={props.onBlur}
          onChangeText={(val) => change(`${val}`)}
          selectionColor={Colors.grayText}
          cursorColor={Colors.grayText}
          height={48}
          showStepper
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    borderRadius: 4,
    paddingVertical: 24,
    paddingHorizontal: 16,
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: Colors.blackText,
    letterSpacing: -0.25,
  },
  inputContainer: {
    width: '100%',
    height: 48,
    marginTop: 20,
    flexDirection: 'row',
    borderRadius: 4,
    overflow: 'hidden',
  },
});
